import React from 'react'
import PropTypes from 'prop-types'
import TextBoxField from './TextBoxField'
import SelectBoxField from './SelectBoxField'
import FileField from './FileField'
import MultipleField from './MultipleField'

const Field = ({ type, submit, question, options, next }) => {
  if (type === 'TEXTO') {
    return (<TextBoxField submit={submit} question={question} />)
  } else if (type === 'SELECCION') {
    return (<SelectBoxField submit={submit} question={question} options={options} />)
  } else if (type === 'ARCHIVO') {
    return (<FileField question={question} submit={submit} next={next} />)
  } else if (type === 'MULTIPLE') {
    return (<MultipleField submit={submit} question={question} options={options} />)
  } else {
    return null
  }
}

Field.propTypes = {
  type: PropTypes.string.isRequired,
  submit: PropTypes.func.isRequired,
  question: PropTypes.object.isRequired,
  next: PropTypes.func.isRequired,
  options: PropTypes.array
}

export default Field
